import { render } from "./contact-item.vue?vue&type=template&id=c1362b36"
import script from "./contact-item.vue?vue&type=script&lang=ts"
export * from "./contact-item.vue?vue&type=script&lang=ts"
script.render = render

export default script